import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import Thumbnails from "../PageProductDetails/Detail/Thumbnails";
import { TextRupiah } from "../Text"
import { connect } from "react-redux"
import styled from "styled-components"
import {
  getFlashSaleCollectionList,
  getFlashSaleSetting
} from "../../actions/productAction";
import { getCloudImageUrl, emptyImage } from "../../utils";
import FlashSaleImage from "../../images/flashsale.png";
import emptySneakerImg from "../../images/emptysneakers2.png";
import emptyApparelImg from "../../images/emptyapparels.png";
import emptyHandbagImg from "../../images/emptyhandbags.png";
import RightArr from "../../images/fs-arrow-right.png";
import LeftArr from "../../images/fs-arrow-left.png";
import Countdown from "react-countdown";
import Slider from "react-slick";
import moment from "moment";
import { RESOURCE_URL } from "../../config"
import { withRouter, history } from "react-router-dom"
import classNames from "classnames";

const PreviousArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 10px;
      width: 20px !important;
      height: 20px !important;
      object-fit: contain;
      border-radius: 30px;
    }

    @media (max-width: 480px) {
      img {
        width: 20px !important;
        height: 20px !important;
        position: absolute;
        left: -36px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={LeftArr} alt="..." />
    </LeftArrow>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 20px !important;
      height: 20px !important;
      object-fit: contain;
      border-radius: 30px;
      right: -5px;
      position: absolute;
    }

    @media (max-width: 480px) {
      img {
        right: 0px !important;
        width: 20px !important;
        height: 20px !important;
        top: -3px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={RightArr} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  lazyLoad: true,
  dots: false,
  swipe: false,
  prevArrow: <PreviousArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  // const newHours = days * 24 + hours;
  return (
    <span style={{ color: "#242424", fontFamily: "Nunito Bold" }}>
      {days < 10 ? `0${days}` : days}<span style={{ fontSize: "10px", fontFamily: "Nunito Light" }}> days</span> {hours < 10 ? `0${hours}` : hours}<span style={{ fontSize: "10px", fontFamily: "Nunito Light" }}> hours</span> {minutes < 10 ? `0${minutes}` : minutes}<span style={{ fontSize: "10px", fontFamily: "Nunito Light" }}> minutes</span> {seconds < 10 ? `0${seconds}` : seconds}<span style={{ fontSize: "10px", fontFamily: "Nunito Light" }}> seconds</span>
    </span>
  );
};

function FlashSale({ getFlashSaleCollectionList, dataCategory, history, getFlashSaleSetting }) {

  const [data, setData] = useState([])

  useEffect(() => {
    getFlashSaleSetting()
      .then(({ value }) => {
        const slug = value.data.data[0].value

        return getFlashSaleCollectionList(dataCategory, slug)
      })
      .then(({ value }) => {
        setData(value.data)
      })
      .catch(e => null)
  }, [dataCategory])

  function onClickProduct(id, slug) {
    history.push(`/${dataCategory}/${id}/${slug}?pre_verified=true`)
  }

  function onClickViewAll(data) {
    history.push(`${dataCategory}/flash-sale`)
  }

  if (data.length <= 0 || moment().format() >= moment(data.expiry).format() || moment().format() <= data.starts_at || data.products.data.length <= 0) return null

  return (
    <div className="container-flash">
      <div className="flash-header">
        <KickImage src={data && data.categories && data.default_images[0] ? getCloudImageUrl(data.default_images[0].URL, 300) : null} alt="Flash sale" />
        <p>End In <Countdown
          date={data.expiry.replace(/\s+/g, 'T')}
          renderer={renderer}
          daysInHours={true}
        /> </p>
      </div>
      <div className="flash-slider">
        <Slider {...settings}>
          {
            data && data.products && data.products.data.map(item => {
              return <div>
                <div style={{ cursor: item.price <= 0 || item.out_of_stock ? "default" : "pointer" }} onClick={item.price > 0 || !item.out_of_stock ? () => onClickProduct(item.id, item.slug) : null} key={item.id} className="slide">
                  <div className="slide-text">
                    <p style={{ color: "#7a7a7a", opacity: item.price <= 0 || item.out_of_stock ? "0.2" : "1" }}>{item.product.brand.name}</p>
                    <p style={{ color: "#242424", fontFamily: "Nunito Bold", height: "30px", opacity: item.price <= 0 || item.out_of_stock ? "0.2" : "1" }}>{item.display_name}</p>
                    <KickImage style={{ opacity: item.price <= 0 || item.out_of_stock ? "0.2" : "1" }} src={item.product_variant_images.length > 0 && new RegExp("\\b" + "s3.amazonaws.com" + "\\b").test(item.product_variant_images[0].URL)
                      ? getCloudImageUrl(
                        item.product_variant_images[0].URL,
                        400
                      )
                      : emptyImage(dataCategory)} alt={item.display_name} />
                    <p style={{ fontFamily: "Nunito Bold", marginTop: window.screen.availWidth < 400 ? "15px" : "20px", textAlign: "center", opacity: item.price <= 0 || item.out_of_stock ? "0.2" : "1" }}>
                      {
                        item.price > 0 ? <TextRupiah
                          prefix="IDR. "
                          color="black"
                          align="center"
                          value={item.price && item.price.toString()}
                          bold={true}
                        /> : "X"
                      }
                    </p>
                  </div>
                </div>
              </div>
            })
          }
        </Slider>
      </div>
      <div onClick={() => onClickViewAll(data)} className="flash-cta">
        <p>View All</p>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  dataCategory: state.dataCategory.selected,
})

const mapDispatchToProps = dispatch => ({
  getFlashSaleCollectionList: (category, slug) => dispatch(getFlashSaleCollectionList(category, slug)),
  getFlashSaleSetting: () => dispatch(getFlashSaleSetting())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FlashSale))
